module.exports = __webpack_public_path__ + "static/media/Icons_start-end.c96ac8de.svg";